
import MobileDetect from 'mobile-detect'
import {detect} from 'detect-browser'
import utils from '@/_fdp/utils'
import FileSaver from 'file-saver'

// import * as moment from 'moment'
import 'moment'
import 'moment/locale/vi'
import 'moment/locale/en-gb'
import 'moment/locale/ko'
import moment from 'moment-timezone'
import vueMoment from 'vue-moment'

import { uniqueId } from 'lodash'
import popupTools from 'popup-tools'
import qs from 'qs'

/*
 * init moment library
 */
moment.locale(localStorage.getItem('langauge')) // default(ko)
// moment().utcOffset(540) // timezone offet Asia/Seoul => GMT+9 => 9 * 60 = 540
moment.tz.setDefault('Asia/Seoul')

const WepUtilsPlugin = {
  install: function (Vue) {
    Vue.use(vueMoment, {
      moment
    })

    let wepUtils = {
      common: {
        openWindowPopup (actionUrl, params, callback, options, post = true) {
          let popupId = uniqueId('wep_w_popup_')
          if (typeof params !== 'object') {
            return
          }

          let defaultOptions = {
            width: 800,
            height: 600,
            menubar: 'no',
            resizable: 'yes',
            location: 'yes',
            scrollbars: 'no',
            centered: true,
            toolbar: 'no',
            status: 'no'
          }

          if (callback !== undefined) {
            var callBackEventFun = function (e, cancelFuc) {
              // receive data
              if (e.data !== undefined && e.data.type !== undefined && e.data.isMmpMessage) {
                callback(e.data)
                Vue.prototype.$removeMessage(cancelFuc, false)
              }
            }

            Vue.prototype.$receiveMessage(callBackEventFun, false)
          }

          if (post) {
            popupTools.popupWithPost(actionUrl, params, popupId, Object.assign({}, defaultOptions, options))
          } else {
            var callUrl = actionUrl + '?' + qs.stringify(params)
            popupTools.popup(callUrl, popupId, Object.assign({}, defaultOptions, options))
          }
        },
        maxLengthCheck (obj, maxlength) {
          var str = obj
          var strLength = str.length
          var tempObj = ''
          if ( strLength > maxlength ) {
            tempObj = str.substr(0, maxlength)
          } else {
            tempObj = str
          }
          return tempObj
        },
        /****************************************************
         * 천단위 표시
         * @param {*} data
         */
        setNumberCommas (data) {
          var returnData = ''
          if ( typeof data !== 'undefined' && data !== '' && data !== null && data !== 'null' ) {
            data = data + ''
            returnData = data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          return returnData
        },
        /****************************************************
         * 문자열 변경
         * @param {*} content 원본 데이터값
         * @param {*} word 변경대상 데이터값
         * @param {*} changeWord 변경할 데이터값
         */
        setReplaceAll (content, word, changeWord) {
          if ( typeof content !== 'undefined' && content !== '' && content !== null && content !== 'null' ) {
            var re = new RegExp(word, 'g')
            content = content + ''
            if ((content && content.indexOf(word) >= 0) || (typeof word === 'object')) {
              content = content.replace(re, changeWord)
            }
          }
          return content
        },
        /****************************************************
         * Enter값 변경
         * @param {*} content 변경할 내용
         * @param {*} changeWord Enter값으로 변경대상 값
         */
        setEnterChange (content, changeWord) {
          var word = /(?:\r\n|\r|\n)/
          changeWord = (changeWord !== '' && typeof changeWord !== 'undefined') ? changeWord : '<br/>'
          if (content && changeWord) {
            return this.setReplaceAll(content, word, changeWord)
          }
          return content
        },
        /****************************************************
         * href tag 삭제
         * @param {*} content 변경할 내용
         */
        removeHrefTag (content) {
          var word = ''
          if (content) {
            return this.setReplaceAll(content, 'href', word)
          }
          return content
        },
        /****************************************************
         * 공백제거
         * @param {*} data
         */
        trim (data) {
          // return data.toString().replace(/(\s*)/g, "")
          if (!data) {
            return ''
          } else {
            return data.replace(/(^\s*)|(\s*$)/gi, '')
          }
        },
        /****************************************************
        *  null -> 공백 변환
        */
        nvl (data) {
          var retunData = this.isNull(data) ? data : ''
          return retunData
        },
        /****************************************************
         * Null 체크
         * @param {String or Object} data
         * @return null: true, not null: false
         */
        isNull (data) {
          var isReturn = true
          if (typeof data === 'string') {
            if (data !== '' && data !== null && data !== 'null' && typeof data !== 'undefined') isReturn = false
          } else {
            if (data !== null && data !== 'null' && typeof data !== 'undefined') isReturn = false
          }
          return isReturn
        },
        /****************************************************
         * Object Empty 체크
         * @param {Object} data
         * @return null: true, not null: false
         */
        isEmpty (data) {
          var isReturn = true
          if ( typeof data !== 'undefined' && data !== null && Object.keys(data).length !== 0 ) {
            isReturn = false
          }
          return isReturn
        },
        isNumberCheck (text) {
          var regNumber = /^[0-9]*$/
          return regNumber.test(text)
        },
        /****************************************************
         * 정규식 체크
         * @param {*} target 정규식 대상(none: regExp값을 사용시, number: 숫자만, email: 이메일, mobile:모바일, phone: 전화번호)
         * @param {*} data 정규식 체크 데이터
         * @param {*} regExp 직접 정규식 사용시
         */
        isRegExp (target, data, regExp) {
          var strRegExp = regExp
          if (target !== 'none') {
            strRegExp = this.getRegExp(target)
          }
          return strRegExp.test(data)
        },
        /****************************************************
         * 정규식 체크
         * @param {*} target 정규식 대상(none: regExp값을 사용시, number: 숫자만, email: 이메일, mobile:모바일, phone: 전화번호)
         */
        getRegExp (target) {
          var strRegExp = ''
          if (target === 'number') {
            // 숫자만 체크 정규식
            strRegExp = /^[0-9]+$/
          } else if (target === 'email') {
            // 이메일 체크 정규식
            // eslint-disable-next-line
            strRegExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
          } else if (target === 'password') {
            // 비밀번호 체크 정규식
            // 비밀번호 8~12자의 숫자, 영문자, 특수문자 모두 포함
            strRegExp = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,12}$/
          } else if (target === 'mobile') {
            // 핸드폰 체크 정규식
            strRegExp = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/
          } else if (target === 'phone') {
            // 전화번호 체크 정규식
            strRegExp = /^\d{2,3}\d{3,4}\d{4}$/
          } else if (target === 'date') {
            // 날짜 정규식 (YYYY-MM-DD)
            strRegExp = /^(19|20)\d{2}.(0[1-9]|1[012]).(0[1-9]|[12][0-9]|3[0-1])$/
          } else if (target === 'newPhone') {
            strRegExp = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})?[0-9]{3,4}?[0-9]{4}$/ // 전화번호 핸드폰번호 070 체크 하는 정규식
          }
          return strRegExp
        },
        /****************************************************
         * 날짜형 문자 포맷
         * @param {*} date
         * @param {*} fomat
         */
        getFomatDateString (date, fomat) {
          var returnData = ''
          if ( !this.isNull(date) ) {
            if ( date.length === 8 || date.length === 6 ) {
              var lastIdx = 4
              if ( date.length === 6 ) {
                lastIdx = 2
              }
              var year = date.substr(0, lastIdx)
              var month = date.substr(lastIdx, 2)
              var day = date.substr(lastIdx + 2, 2)
              returnData = year + fomat + month + fomat + day
            }
          }
          return returnData
        },
        /****************************************************
         * 자리수 0 채우기
         * @param {*} data 원본 데이터값
         * @param {*} digits 총 자릿수
         */
        getZeros (data, digits) {
          var zero = ''
          data = data.toString()
          if (data.length < digits) {
            for (var i = 0; i < digits - data.length; i++) { zero += '0' }
          }
          return zero + data
        },
        /****************************************************
         * 날짜 조회
         * @param {*} type
         */
        getDate (type) {
          switch (type) {
            case 'yyyy': return moment().format('YYYY')
            case 'yy': return moment().format('YY')
            case 'MM': return moment().format('MM')
            case 'dd': return moment().format('DD')
            case 'weeks': return moment.weekdays()
            case 'week': return moment().format('dddd')
            case 'HH': return moment().format('HH')
            case 'hh': return moment().format('hh')
            case 'mm': return moment().format('mm')
            case 'ss': return moment().format('ss')
            case 'a/p': return moment().format('a')
            case 'A/P': return moment().format('A')
            default: return moment().format() // "2019-05-02T18:52:50+09:00"
          }
        },
        /****************************************************
         * 현재년도 조회
         */
        getNowYear () {
          return this.getDate('yyyy')
        },
        /****************************************************
         * 현재일자 조회
         * @param {*} gubun - or / or .
         */
        getNowMonth () {
          return this.getDate('MM')
        },
        getNowDay (gubun) {
          if ( typeof gubun === 'undefined' || gubun === '' || gubun === null ) { gubun = '.' }
          return this.getDate('yyyy') + gubun + this.getDate('MM') + gubun + this.getDate('dd')
        },
        getConvertDate (val, type) {
          if ( type === 0 ) {
            return moment(val).format('YYYY.MM.DD')
          } else if ( type === 9 ) {
            return moment(val).format('HH:mm')
          } else if ( type === 24 ) {
            return moment(val).format('YYYYMMDDHHmm')
          } else if ( type === 60 ) {
            return moment(val).format('YYYYMMDDHHmmss')
          } else {
            return moment(val).format('YYYY.MM.DD HH:mm')
          }
        },
        /****************************************************
         * 기준 날짜로 부터 day, month 가져오기
         * @param {Date} day
         * @param {Number} add
         * @param {String} type ('days', 'month')
         */
        getAddDate (day, add, type) {
          if ( day === null || day === undefined || day === '' ) {
            return moment().add(add, type).format('YYYY-MM-DD')
          } else {
            return moment(day).add(add, type).format('YYYY-MM-DD')
          }
        },
        /****************************************************
         * 시간(sec)로 시간 조회
         * @param {*} value 초(sec)
         * @returns 시간:분:초
         */
        timeInHours (value) {
          if ( typeof value !== 'undefined' && value !== null && value !== 0 ) {
            let hours = parseInt(Math.floor(value / 3600))
            let minutes = parseInt(Math.floor((value - (hours * 3600)) / 60))
            let seconds = Math.round((value - ((hours * 3600) + (minutes * 60))) % 60)

            let dHours = (hours > 9 ? hours : '0' + hours)
            let dMins = (minutes > 9 ? minutes : '0' + minutes)
            let dSecs = (seconds > 9 ? seconds : '0' + seconds)

            if (Number(dHours) > 0) {
              return dHours + ':' + dMins + ':' + dSecs
            } else {
              return dMins + ':' + dSecs
            }
          } else {
            return '00:00'
          }
        },
        base64ToBlob (base64, contentType, sliceSize) {
          contentType = contentType || ''
          sliceSize = sliceSize || 512

          var byteCharacters = atob(base64)
          var byteArrays = []

          for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize)

            var byteNumbers = new Array(slice.length)
            for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i)
            }

            var byteArray = new Uint8Array(byteNumbers)

            byteArrays.push(byteArray)
          }

          return new Blob(byteArrays, {type: contentType})
        },
        base64ToByteArray (base64) {
          let binaryString = window.atob(base64)
          let binaryLen = binaryString.length
          let bytes = new Uint8Array(binaryLen)
          for (let i = 0; i < binaryLen; i++) {
            let ascii = binaryString.charCodeAt(i)
            bytes[i] = ascii
          }
          return bytes
        },
        saveFileByteArray (name, byte, type) {
          if (!type) type = 'application/octet'
          const url = window.URL.createObjectURL(new Blob([byte], {type: type}))
          const link = document.createElement('a')
          link.href = url
          link.download = name
          link.click()
        },
        saveFile (name, base64, type, ext, vm) {
          if (!type) type = 'application/octet'
          let iosType = ''
          if (ext === 'jpg') {
            iosType = 'application/jpg'
          } else if (ext === 'xls') {
            iosType = 'application/vnd.ms-excel'
          } else if (ext === 'xlsx') {
            iosType = 'application / vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          } else if (ext === 'pptx') {
            iosType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          } else if (ext === 'ppt') {
            iosType = 'application/vnd.ms-powerpoint'
          } else if (ext === 'doc') {
            iosType = 'application / msword'
          } else if (ext === 'docx') {
            iosType = 'application / vnd.openxmlformats-officedocument.wordprocessingml.document'
          } else if (ext === 'pdf') {
            iosType = 'application/pdf'
          } else if (ext === 'txt') {
            iosType = 'text/plain;charset=utf-8'
          }
          const binaryString = window.atob(base64)
          const binaryLen = binaryString.length
          const bytes = new Uint8Array(binaryLen)
          for (let i = 0; i < binaryLen; i++) {
            let ascii = binaryString.charCodeAt(i)
            bytes[i] = ascii
          }
          if (utils.getUserAgent().iOS) {
            if (iosType !== '') {
              FileSaver.saveAs(new Blob([bytes], {type: iosType}), name)
            } else {
              vm.$popup.open({
                cancelable: false,
                message: vm.$t('MSEM0284'),
                confirmInput: vm.$t('TSEM001025') // 확인
              })
            }
          } else {
            const url = window.URL.createObjectURL(new Blob([bytes], {type: type}))
            const link = document.createElement('a')
            link.href = url
            link.download = name
            document.body.appendChild(link)
            link.click()
          }
        },
        /**
         * 파일명에서 확장자명 추출
         * @param filename   파일명
         * @returns _fileExt 확장자명
         */
        getExtensionOfFilename (filename) {
          const _fileLen = filename.length
          /**
           * lastIndexOf('.')
           * 뒤에서부터 '.'의 위치를 찾기위한 함수
           * 검색 문자의 위치를 반환한다.
           * 파일 이름에 '.'이 포함되는 경우가 있기 때문에 lastIndexOf() 사용
           */
          const _lastDot = filename.lastIndexOf('.')

          // 확장자 명만 추출한 후 소문자로 변경
          const _fileExt = filename.substring(_lastDot, _fileLen).toLowerCase()

          return _fileExt
        },
        /**
         * 미리보기 가능한 확장자인지 체크
         * @param fileExt   확장자명
         * @param extList   허용 확장자 리스트
         * @returns result true/false
         */
        checkExtension (fileExt, extList) {
          let result

          // 미리보기 가능한 확장자는 배열에 넣기
          let _arrExt = ['.xls', '.xlsx', '.ppt', '.pptx', '.doc', '.docx', '.pdf', '.txt', '.bmp', '.gif', '.tip', '.jpg', '.png', '.jpeg']
          if (extList && extList.length > 0) _arrExt = extList

          // 배열 요소를 검사하여 체크
          for (let i = 0; i < _arrExt.length; i++) {
            if (_arrExt[i] === fileExt) {
              result = true
              break
            } else {
              result = false
            }
          }

          return result
        },
        /**
         * Formates file size.
         *
         * @param {Number|String} size
         */
        formatFileSize (size, fixed) {
          const units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
          const threshold = 1024
          if (!fixed) fixed = 2
          size = Number(size)
          const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold))
          return `${(size / Math.pow(threshold, i)).toFixed(Number(fixed)) * 1} ${units[i]}`
        },
        /****************************************************
         * 바이트 변환
         * @param {*} byte 실제 파일 크기
         * @param {*} fixed 소수점 자릿수
         */
        getFileFormatBytes (fileSize, fixed) {
          let decimalNum = 1

          if ( typeof fixed === 'undefined' || fixed === null ) {
            fixed = 2
          }

          for (let i = 0; i < fixed; i++) {
            decimalNum = decimalNum * 10
          }

          // MB 단위 이상일때 MB 단위로 환산
          if (fileSize >= 1024 * 1024) {
            fileSize = fileSize / (1024 * 1024)
            fileSize = Math.floor(fileSize * decimalNum) / decimalNum
          } else if (fileSize >= 1024) { // KB 단위 이상일때 KB 단위로 환산
            fileSize = fileSize / 1024
            fileSize = Math.floor(fileSize * decimalNum) / decimalNum
          } else { // KB 단위보다 작을때 byte 단위로 환산
            fileSize = Math.floor(fileSize * decimalNum) / decimalNum
          }

          return this.setNumberCommas(fileSize)
        },
        /**
         * 바이트 단위 변환
         * @param {*} fileSize 실제 파일 크기
         */
        getFileFormatUnits (fileSize) {
          var returnUnit = ''

          // MB 단위 이상일때 MB 단위로 환산
          if (fileSize >= 1024 * 1024) {
            returnUnit = 'MB'
          } else if (fileSize >= 1024) { // KB 단위 이상일때 KB 단위로 환산
            returnUnit = 'KB'
          } else { // KB 단위보다 작을때 byte 단위로 환산
            returnUnit = 'byte'
          }
          return returnUnit
        },
        /****************************************************
         * Array Object 중복 제거
         * @param {*} array 배열
         * @param {*} key object key
         * @param {*} key2 object key (optional)
         */
        getUniqueObjectArray (array, key, key2) {
          return array.filter((item, i) => {
            return array.findIndex((item2, j) => {
              if (key2) {
                return item[key] === item2[key] && item[key2] === item2[key2]
              } else {
                return item[key] === item2[key]
              }
            }) === i
          })
        },
        /**
         * 맨앞 숫자 0 제거
         * @param {*} val
         */
        removeFrontZero (val) {
          return val.replace(/(^0+)/, '')
        },
        /*
          name: jindoChk
          용도: 일일진도량 체크 테스트 -> 1주일간 보지 않기 컨트롤
          작성자: 김동욱
          수정 : 2019-04-23
          수정 이유 : 일일진도량 체크로직 수정에 따른 미사용
        */
        // jindoChk (nextLrnCd) {
        //   let popOpen = false
        //   let date = new Date()
        //   let month = 0
        //   let day = 0
        //   let today = 0

        //   if (date.getMonth() + 1 < 10) {
        //     month = '0' + (date.getMonth() + 1)
        //   }

        //   if (date.getDate() < 10) {
        //     day = '0' + date.getDate()
        //   }
        //   today = date.getFullYear() + month + day
        //   if (nextLrnCd === '04') {
        //     popOpen = true
        //     if (localStorage.getItem('showYn')) { // 스토리지에 있을경우
        //       let show = (Number(today) - Number(localStorage.getItem('showYn'))) < 7
        //       if (show) { // 오늘날짜 - 저장한값 일주일 이상 차이나지 않는다
        //         popOpen = false
        //       }
        //     }
        //   }
        //   return popOpen
        // },
        /****************************************************
         * 특수기호가 포함된 내용 Html 소스로 변경
         * @param {*} val
         */
        getChangeSpecialHtml (val) {
          var tempDiv = document.createElement('div')
          tempDiv.innerHTML = val
          return tempDiv.innerText
        },
        /****************************************************
        목적: 받은 타입에 따라 날짜를 변경해서 반환
        사용법: 1) value에 20180311, 2) type에 'YYYY년M월'로 넣어주면 2018.3월로 변경됩니다.
         * @param {*} value 20180311
         * @param {*} type 'YYYY년M월'
        작성자: 김정윤
        */
        setDateFormat (value, type) {
          if (value !== null) {
            value = String(value)
            type = String(type)
            return moment(value).format(type)
          }
        },
        /****************************************************
        목적: text-field의 입력값 여부를 검사
        * @param {*} val 텍스트 입력값
        작성자: 김정윤
        */
        emptyCheck ( val ) {
          if (val === '' || val === null || val === undefined) {
            return false
          } else {
            return true
          }
        },
        /**
         * 파일명에서 확장자명 추출
         * @param filename   파일명
         * @returns _fileExt 확장자명
         */
        getExtOfFilename (filename) {
          let _fileLen = filename.length
          /**
           * lastIndexOf('.')
           * 뒤에서부터 '.'의 위치를 찾기위한 함수
           * 검색 문자의 위치를 반환한다.
           * 파일 이름에 '.'이 포함되는 경우가 있기 때문에 lastIndexOf() 사용
           */
          let _lastDot = filename.lastIndexOf('.')

          // 확장자 명만 추출한 후 소문자로 변경
          let _fileExt = filename.substring(_lastDot, _fileLen).toLowerCase()

          return _fileExt
        }
      },
      paging: {
        /****************************************************
         * 페이징 시작 Num
         * @param {*} pIdx 조회 페이지 Index
         * @param {*} pRowNum
         */
        getStartPageNum (pIdx, pRowNum) {
          if ( typeof pRowNum === 'undefined' || pRowNum === null ) {
            pRowNum = 10
          }
          return pIdx * pRowNum
        },
        /****************************************************
         * 페이징 종료 Num
         * @param {*} pIdx 조회 페이지 Index
         * @param {*} pRowNum
         */
        getEndPageNum (pIdx, pRowNum) {
          if ( typeof pRowNum === 'undefined' || pRowNum === null ) {
            pRowNum = 10
          }
          return ( (pIdx + 1) * pRowNum ) - 1
        }
      },
      userAgent: {
        detector: {},
        init () {
          this.detector = new MobileDetect(window.navigator.userAgent)
        },
        isDesktop () {
          // return this.detector.is('DesktopMode')
          return (!this.detector.phone() && !this.detector.tablet())
        },
        isTablet () {
          return (this.detector.tablet())
        },
        isPhone () {
          return (this.detector.phone() && !this.detector.tablet())
        },
        isApp () {
          return utils.getUserAgent().WEB_VIEW
          // return this.detector.match(new RegExp(window.vue.config.app.appAgentString))
        },
        isIE () {
          var browser = detect()

          return (browser && browser.name === 'ie')
        }
      },
      moment: {
        /*
         * [참고사항] https://momentjs.com/docs/
         * moment(time, format)
         * time: 현재시간 혹은 변경이 필요한 시간
         * format: 입력된 time(시간)의 format
         * ex) moment() : 현재 시간
         * ex) moment('10.04.2019 17:18', 'DD.MM.YYYY HH:mm') : 입력된 시간
         *
         * moment().format() : 입력된 시간을 지정된 format으로 변경
         * ex) moment().format('YYYY.MM.DD HH:mm') : 현재 시간을 년.월.일 시:분 형태로 반환
         * ex) moment('10.04.2019 17:18', 'DD.MM.YYYY HH:mm').format('YYYY.MM.DD HH:mm') : 입력된 시간을 년.월.일 시:분 형태로 반환
         */
        get (time, format) { // moment
          return moment(time, format)
        },
        now () { // now timestamp
          return moment().toDate().getTime()
        },
        getDate (time, format) { // javascript: new Date()
          return moment(time, format).toDate()
        },
        getTime (time, format) { // timestamp
          return moment(time, format).toDate().getTime()
        },
        getDefault () { // default information
          return {
            locale: {
              langCode: localStorage.getItem('language') || 'ko',
              dateformatCode: localStorage.getItem('dateFormat') || 'ko',
              timeZoneCode: localStorage.getItem('timeZone') || 'Asia/Seoul',
              currentDate: moment().toDate().getTime(), // 1555996328000
              currentDateString: moment().format() + '[Asia/Seoul]', // "2019-04-23T14:12:08+09:00[Asia/Seoul]"
              dateformat: window.vue.getStore('root').getters.getDateFormat
            }
          }
        },
        setLocale (locale) { // set locale
          return moment.locale(locale)
        },
        /*
         * setTimeZone 메소드 사용 제한
         * 서버의 데이터 타임존이 기본 Asia/Seoul 기준으로 내려옴
         * 추후 서버의 데이터가 타임존에 따라 내려오는 경우 주석을 풀고 사용
         */
        setTimeZone (timeZone) { // set timezone ('Asia/Seoul')
          return moment.tz.setDefault(timeZone)
          // return moment.tz.setDefault('Asia/Seoul')
        },
        formatter (time, format) {
          return moment(time).format(format)
        }
      },
      app: {
        config () {
          return window.vue.config.app
        }
      },
      user: {
        autoLogin () {
          if (localStorage.getItem('autoLogin') && typeof JSON.parse(localStorage.getItem('autoLogin')) === 'object') {
            let autoLogin = JSON.parse(localStorage.getItem('autoLogin'))
            if (autoLogin && autoLogin.session && autoLogin.token) {
              let session = autoLogin.session
              let token = autoLogin.token

              // 사용자 session, token 처리
              window.vue.getStore('root').dispatch('LOG_IN', {session})
              window.vue.getStore('token').dispatch('REGISTER', {token})

              // device에 사용자 정보 저장
              if (utils.getUserAgent().WEB_VIEW) this.setDeviceUserInfo(session, token)

              // 메인탭 localStorage init (190407 이승진)
              window.localStorage.setItem('tabMem', '')
              window.localStorage.removeItem('tabMem')

              return true
            } else { // session, token 정보가 없는 경우 자동 로그인 정보 삭제
              window.localStorage.setItem('autoLogin', '')
              window.localStorage.removeItem('autoLogin')

              return false
            }
          }
        },
        logout () {
          document.getElementById('panoptoLogout').src = 'https://classnow.utime.kr/wp/wp-login.php?action=wp-saml-auth&SSO_LOGOUT'
          window.vue.getStore('token').commit('DELETE')
          window.vue.getStore('mmpAuth').commit('CLEAR_AUTO_LOGIN')
          window.vue.getStore('root').commit('LOG_OUT')
        },
        setDeviceUserInfo (session, token) {
          // R/N user plugin
          let data = {
            userId: session.userId,
            mbrNo: session.mbrNo,
            mbrFnm: session.mbrFnm,
            information: window.vue.getStore('root').getters.getInformation,
            token,
            session,
            locale: localStorage.getItem('language')
          }

          window.fdpbridge.exec('getConfigPlugin', data,
            (success) => {
              console.log(success)
            },
            (error) => {
              console.log(error.message)
            })
        }
      },
      getClr2 () {
        let clr = this.common.getBrandRGBColor('clr2')
        return clr
      }
    }
    Vue.utils = Vue.prototype.$utils = wepUtils

    Vue.utils.userAgent.init()
  }
}

export default WepUtilsPlugin



// WEBPACK FOOTER //
// ./src/plugins/_common/WepUtils.js